import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Index from '@/components/Index'


Vue.use(Router)

// 路由懒加载
const Binding = (resolve) => {
  import('@/components/Binding').then((module) => {
    resolve(module)
  })
}
const Signup = (resolve) => {
  import('@/components/Signup').then((module) => {
    resolve(module)
  })
}
const Signsuccess = (resolve) => {
  import('@/components/Signsuccess').then((module) => {
    resolve(module)
  })
}
const Selectcar = (resolve) => {
  import('@/components/Selectcar').then((module) => {
    resolve(module)
  })
}
const Selectschool = (resolve) => {
  import('@/components/Selectschool').then((module) => {
    resolve(module)
  })
}
const Selectstu = (resolve) => {
  import('@/components/Selectstu').then((module) => {
    resolve(module)
  })
}
const Stuprogress = (resolve) => {
  import('@/components/Stuprogress').then((module) => {
    resolve(module)
  })
}
const Identifyjl = (resolve) => {
  import('@/components/Identifyjl').then((module) => {
    resolve(module)
  })
}
const Identifyjx = (resolve) => {
  import('@/components/Identifyjx').then((module) => {
    resolve(module)
  })
}
const Identifyllpx = (resolve) => {
  import('@/components/Identifyllpx').then((module) => {
    resolve(module)
  })
}
const Identifytgy = (resolve) => {
  import('@/components/Identifytgy').then((module) => {
    resolve(module)
  })
}
const Myindex = (resolve) => {
  import('@/components/Myindex').then((module) => {
    resolve(module)
  })
}
const Merchantin = (resolve) => {
  import('@/components/Merchantin').then((module) => {
    resolve(module)
  })
}

const Shopindex = (resolve) => {
  import('@/components/Shopindex').then((module) => {
    resolve(module)
  })
}
const Shoplist = (resolve) => {
  import('@/components/Shoplist').then((module) => {
    resolve(module)
  })
}
const Myawards = (resolve) => {
  import('@/components/Myawards').then((module) => {
    resolve(module)
  })
}
const Wxoauth = (resolve) => {
  import('@/components/Wxoauth').then((module) => {
    resolve(module)
  })
}
const Shopdetail = (resolve) => {
  import('@/components/Shopdetail').then((module) => {
    resolve(module)
  })
}
const Detailinfo = (resolve) => {
  import('@/components/Detailinfo').then((module) => {
    resolve(module)
  })
}
const Detailjl = (resolve) => {
  import('@/components/Detailjl').then((module) => {
    resolve(module)
  })
}
const Detailjx = (resolve) => {
  import('@/components/Detailjx').then((module) => {
    resolve(module)
  })
}
const Stuinvite = (resolve) => {
  import('@/components/Stuinvite').then((module) => {
    resolve(module)
  })
}
const Mypicture = (resolve) => {
  import('@/components/Mypicture').then((module) => {
    resolve(module)
  })
}
const Mypicturedetail = (resolve) => {
  import('@/components/Mypicturedetail').then((module) => {
    resolve(module)
  })
}
const Contact = (resolve) => {
  import('@/components/Contact').then((module) => {
    resolve(module)
  })
}
const Feedback = (resolve) => {
  import('@/components/Feedback').then((module) => {
    resolve(module)
  })
}
const Newsdetail = (resolve) => {
  import('@/components/Newsdetail').then((module) => {
    resolve(module)
  })
}
const Contractlist = (resolve) => {
  import('@/components/Contractlist').then((module) => {
    resolve(module)
  })
}
const Contractdetail = (resolve) => {
  import('@/components/Contractdetail').then((module) => {
    resolve(module)
  })
}
const Stulist = (resolve) => {
  import('@/components/Stulist').then((module) => {
    resolve(module)
  })
}
const Studetail = (resolve) => {
  import('@/components/Studetail').then((module) => {
    resolve(module)
  })
}
const Tuijianlilun = (resolve) => {
  import('@/components/Tuijianlilun').then((module) => {
    resolve(module)
  })
}
const Tuijianvideo = (resolve) => {
  import('@/components/Tuijianvideo').then((module) => {
    resolve(module)
  })
}
const Newslist = (resolve) => {
  import('@/components/Newslist').then((module) => {
    resolve(module)
  })
}
const Mywallet = (resolve) => {
  import('@/components/Mywallet').then((module) => {
    resolve(module)
  })
}
const Myteam = (resolve) => {
  import('@/components/Myteam').then((module) => {
    resolve(module)
  })
}
const Invite = (resolve) => {
  import('@/components/Invite').then((module) => {
    resolve(module)
  })
}
const Mypictureadd = (resolve) => {
  import('@/components/Mypictureadd').then((module) => {
    resolve(module)
  })
}
const Payinfo = (resolve) => {
  import('@/components/Payinfo').then((module) => {
    resolve(module)
  })
}
const Pay = (resolve) => {
  import('@/components/Pay').then((module) => {
    resolve(module)
  })
}
const Tixiandetail = (resolve) => {
  import('@/components/Tixiandetail').then((module) => {
    resolve(module)
  })
}
const Tixianmx = (resolve) => {
  import('@/components/Tixianmx').then((module) => {
    resolve(module)
  })
}
const Yongjinmx = (resolve) => {
  import('@/components/Yongjinmx').then((module) => {
    resolve(module)
  })
}
const Walletorder = (resolve) => {
  import('@/components/Walletorder').then((module) => {
    resolve(module)
  })
}
const Tuijianpicture = (resolve) => {
  import('@/components/Tuijianpicture').then((module) => {
    resolve(module)
  })
}
const Contractexamine = (resolve) => {
  import('@/components/Contractexamine').then((module) => {
    resolve(module)
  })
}
const Contractjl = (resolve) => {
  import('@/components/Contractjl').then((module) => {
    resolve(module)
  })
}
const Setup = (resolve) => {
  import('@/components/Setup').then((module) => {
    resolve(module)
  })
}
const Barcode = (resolve) => {
  import('@/components/Barcode').then((module) => {
    resolve(module)
  })
}
const Bindinginfo = (resolve) => {
  import('@/components/Bindinginfo').then((module) => {
    resolve(module)
  })
}
const Addprize = (resolve) => {
  import('@/components/Addprize').then((module) => {
    resolve(module)
  })
}
const Prize = (resolve) => {
  import('@/components/Prize').then((module) => {
    resolve(module)
  })
}
const Prizeinfo = (resolve) => {
  import('@/components/Prizeinfo').then((module) => {
    resolve(module)
  })
}
const Prizelist = (resolve) => {
  import('@/components/Prizelist').then((module) => {
    resolve(module)
  })
}
const Prizeuser = (resolve) => {
  import('@/components/Prizeuser').then((module) => {
    resolve(module)
  })
}
const Poster = (resolve) => {
  import('@/components/Poster').then((module) => {
    resolve(module)
  })
}
const Posterdown = (resolve) => {
  import('@/components/Posterdown').then((module) => {
    resolve(module)
  })
}
const Posterset = (resolve) => {
  import('@/components/Posterset').then((module) => {
    resolve(module)
  })
}
const Yuyue = (resolve) => {
  import('@/components/Yuyue').then((module) => {
    resolve(module)
  })
}
const Paiche = (resolve) => {
  import('@/components/Paiche').then((module) => {
    resolve(module)
  })
}
const Infojx = (resolve) => {
  import('@/components/Infojx').then((module) => {
    resolve(module)
  })
}
const Infolist = (resolve) => {
  import('@/components/Infolist').then((module) => {
    resolve(module)
  })
}
const Infoadd = (resolve) => {
  import('@/components/Infoadd').then((module) => {
    resolve(module)
  })
}
const Setupjx = (resolve) => {
  import('@/components/Setupjx').then((module) => {
    resolve(module)
  })
}
const Setupjl = (resolve) => {
  import('@/components/Setupjl').then((module) => {
    resolve(module)
  })
}
const Infogl = (resolve) => {
  import('@/components/Infogl').then((module) => {
    resolve(module)
  })
}
const Map = (resolve) => {
  import('@/components/Map').then((module) => {
    resolve(module)
  })
}
const Contractinfo = (resolve) => {
  import('@/components/Contractinfo').then((module) => {
    resolve(module)
  })
}
const Contractlists = (resolve) => {
  import('@/components/Contractlists').then((module) => {
    resolve(module)
  })
}
const Contractschool = (resolve) => {
  import('@/components/Contractschool').then((module) => {
    resolve(module)
  })
}
const Conserve = (resolve) => {
  import('@/components/Conserve').then((module) => {
    resolve(module)
  })
}
const Conservevideo = (resolve) => {
  import('@/components/Conservevideo').then((module) => {
    resolve(module)
  })
}
const Introduce = (resolve) => {
  import('@/components/Introduce').then((module) => {
    resolve(module)
  })
}
const Prizesend = (resolve) => {
  import('@/components/Prizesend').then((module) => {
    resolve(module)
  })
}
const Sharelist = (resolve) => {
  import('@/components/Sharelist').then((module) => {
    resolve(module)
  })
}
const Sharequestions = (resolve) => {
  import('@/components/Sharequestions').then((module) => {
    resolve(module)
  })
}
const Sharevideo = (resolve) => {
  import('@/components/Sharevideo').then((module) => {
    resolve(module)
  })
}
const Sharephoto = (resolve) => {
  import('@/components/Sharephoto').then((module) => {
    resolve(module)
  })
}
const Proxylogin = (resolve) => {
  import('@/components/Proxylogin').then((module) => {
    resolve(module)
  })
}
const Proxywallet = (resolve) => {
  import('@/components/Proxywallet').then((module) => {
    resolve(module)
  })
}
const Proxytixian = (resolve) => {
  import('@/components/Proxytixian').then((module) => {
    resolve(module)
  })
}
const Proxyprofit = (resolve) => {
  import('@/components/Proxyprofit').then((module) => {
    resolve(module)
  })
}
const Myproxy = (resolve) => {
  import('@/components/Myproxy').then((module) => {
    resolve(module)
  })
}
const Myproxyxia = (resolve) => {
  import('@/components/Myproxyxia').then((module) => {
    resolve(module)
  })
}
const Proxycode = (resolve) => {
  import('@/components/Proxycode').then((module) => {
    resolve(module)
  })
}
const Proxymix = (resolve) => {
  import('@/components/Proxymix').then((module) => {
    resolve(module)
  })
}

const Income = (resolve) => {
  import('@/components/Income').then((module) => {
    resolve(module)
  })
}

const Corder = (resolve) => {
  import('@/components/Corder').then((module) => {
    resolve(module)
  })
}
const Promoter = (resolve) => {
  import('@/components/Promoter').then((module) => {
    resolve(module)
  })
}
const Integral = (resolve) => {
  import('@/components/Integral').then((module) => {
    resolve(module)
  })
}
const Obtain = (resolve) => {
  import('@/components/Obtain').then((module) => {
    resolve(module)
  })
}

// begin old h5=================================================>
const H5Index = (resolve) => {
  import('@/components/driving_test/Index').then((module) => {
    resolve(module)
  })
}
const Fee = (resolve) => {
  import('@/components/driving_test/Fee').then((module) => {
    resolve(module)
  })
}
const Learn = (resolve) => {
  import('@/components/driving_test/Learn').then((module) => {
    resolve(module)
  })
}
const Subjectlist = (resolve) => {
  import('@/components/driving_test/Subjectlist').then((module) => {
    resolve(module)
  })
}
const Subjectlistresult = (resolve) => {
  import('@/components/driving_test/Subjectlistresult').then((module) => {
    resolve(module)
  })
}
const Video = (resolve) => {
  import('@/components/driving_test/Video').then((module) => {
    resolve(module)
  })
}
const Video1 = (resolve) => {
  import('@/components/driving_test/Video1').then((module) => {
    resolve(module)
  })
}
const Videodetail = (resolve) => {
  import('@/components/driving_test/Videodetail').then((module) => {
    resolve(module)
  })
}
const Videovip = (resolve) => {
  import('@/components/driving_test/Videovip').then((module) => {
    resolve(module)
  })
}
const Vip = (resolve) => {
  import('@/components/driving_test/Vip').then((module) => {
    resolve(module)
  })
}
const Subjectvip = (resolve) => {
  import('@/components/driving_test/Subjectvip').then((module) => {
    resolve(module)
  })
}
const Result = (resolve) => {
  import('@/components/driving_test/Result').then((module) => {
    resolve(module)
  })
}
const Chapter = (resolve) => {
  import('@/components/driving_test/Chapter').then((module) => {
    resolve(module)
  })
}
const Compensate = (resolve) => {
  import('@/components/driving_test/Compensate').then((module) => {
    resolve(module)
  })
}
const Wrong = (resolve) => {
  import('@/components/driving_test/Wrong').then((module) => {
    resolve(module)
  })
}
const Orders = (resolve) => {
  import('@/components/driving_test/Orders').then((module) => {
    resolve(module)
  })
}
const Payresult = (resolve) => {
  import('@/components/driving_test/Payresult').then((module) => {
    resolve(module)
  })
}
const Videocourse = (resolve) => {
  import('@/components/driving_test/Videocourse').then((module) => {
    resolve(module)
  })
}
const Compensateform = (resolve) => {
  import('@/components/driving_test/Compensateform').then((module) => {
    resolve(module)
  })
}



// end old h5========================================================>

const Feevideo = (resolve) => {
  import('@/components/driving_test/Feevideo').then((module) => {
    resolve(module)
  })
}
const Myextension = (resolve) => {
  import('@/components/Myextension').then((module) => {
    resolve(module)
  })
}
const Rankingdl = (resolve) => {
  import('@/components/Rankingdl').then((module) => {
    resolve(module)
  })
}
const Rankingtg = (resolve) => {
  import('@/components/Rankingtg').then((module) => {
    resolve(module)
  })
}

// 油卡
const OilIndex = (resolve) => {
  import('@/components/oil_card/Index').then((module) => {
    resolve(module)
  })
}
const Search = (resolve) => {
  import('@/components/oil_card/Search').then((module) => {
    resolve(module)
  })
}
const Recharge = (resolve) => {
  import('@/components/oil_card/Recharge').then((module) => {
    resolve(module)
  })
}
const Rechargerecord = (resolve) => {
  import('@/components/oil_card/Rechargerecord').then((module) => {
    resolve(module)
  })
}
const Personal = (resolve) => {
  import('@/components/oil_card/Personal').then((module) => {
    resolve(module)
  })
}
const Exchangerecord = (resolve) => {
  import('@/components/oil_card/Exchangerecord').then((module) => {
    resolve(module)
  })
}
const Oilcontact = (resolve) => {
  import('@/components/oil_card/Oilcontact').then((module) => {
    resolve(module)
  })
}
const Oildetail= (resolve) => {
  import('@/components/oil_card/Oildetail').then((module) => {
    resolve(module)
  })
}
const Oilabout= (resolve) => {
  import('@/components/oil_card/Oilabout').then((module) => {
    resolve(module)
  })
}
const Oilsettle= (resolve) => {
  import('@/components/oil_card/Oilsettle').then((module) => {
    resolve(module)
  })
}
const Oilfeedback= (resolve) => {
  import('@/components/oil_card/Oilfeedback').then((module) => {
    resolve(module)
  })
}
const Oilpromoter= (resolve) => {
  import('@/components/oil_card/Oilpromoter').then((module) => {
    resolve(module)
  })
}
const Oilagent= (resolve) => {
  import('@/components/oil_card/Oilagent').then((module) => {
    resolve(module)
  })
}
const Cardquery= (resolve) => {
  import('@/components/oil_card/Cardquery').then((module) => {
    resolve(module)
  })
}
const Cardrecharge= (resolve) => {
  import('@/components/oil_card/Cardrecharge').then((module) => {
    resolve(module)
  })
}
const Cardmerchant= (resolve) => {
  import('@/components/oil_card/Cardmerchant').then((module) => {
    resolve(module)
  })
}
const Cardagent= (resolve) => {
  import('@/components/oil_card/Cardagent').then((module) => {
    resolve(module)
  })
}
const Rebate= (resolve) => {
  import('@/components/oil_card/Rebate').then((module) => {
    resolve(module)
  })
}
const Cardadminister= (resolve) => {
  import('@/components/oil_card/Cardadminister').then((module) => {
    resolve(module)
  })
}
const Cardrecord= (resolve) => {
  import('@/components/oil_card/Cardrecord').then((module) => {
    resolve(module)
  })
}
const Oilpartner= (resolve) => {
  import('@/components/oil_card/Oilpartner').then((module) => {
    resolve(module)
  })
}
const Oilorder= (resolve) => {
  import('@/components/oil_card/Oilorder').then((module) => {
    resolve(module)
  })
}
const Oilmember= (resolve) => {
  import('@/components/oil_card/Oilmember').then((module) => {
    resolve(module)
  })
}
const Profitrecord= (resolve) => {
  import('@/components/oil_card/Profitrecord').then((module) => {
    resolve(module)
  })
}
const Oiltixian= (resolve) => {
  import('@/components/oil_card/Oiltixian').then((module) => {
    resolve(module)
  })
}
const Redeem= (resolve) => {
  import('@/components/oil_card/Redeem').then((module) => {
    resolve(module)
  })
}
const Rechargeproduct = (resolve) => {
  import('@/components/oil_card/Rechargeproduct').then((module) => {
    resolve(module)
  })
}
// 优惠卡券
const Discount = (resolve) => {
  import('@/components/Discount').then((module) => {
    resolve(module)
  })
}
const Discountdetail = (resolve) => {
  import('@/components/Discountdetail').then((module) => {
    resolve(module)
  })
}
const Discountshop = (resolve) => {
  import('@/components/Discountshop').then((module) => {
    resolve(module)
  })
}
const Discountshopdetail = (resolve) => {
  import('@/components/Discountshopdetail').then((module) => {
    resolve(module)
  })
}



const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '首页',
        isShowHead: false,
        isShowFoot: true,
        isShowBack: false,
        keepAlive: true
      }
    },
    {
      path: '/shop',
      name: 'Shopindex',
      component: Shopindex,
      meta: {
        title: '商城',
        isShowHead: false,
        isShowFoot: true,
        isShowBack: false,
        keepAlive: true
      }
    },
    {
      path: '/my',
      name: 'Myindex',
      component: Myindex,
      meta: {
        title: '我的',
        isShowHead: false,
        isShowFoot: true,
        isShowBack: false
      }
    },
    {
      path: '/binding',
      name: 'Binding',
      component: Binding,
      meta: {
        title: '绑定手机号',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title: '报名',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: true,
        keepAlive: true
      }
    },
    {
      path: '/signsuccess',
      name: 'Signsuccess',
      component: Signsuccess,
      meta: {
        title: '报名成功',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/selectcar',
      name: 'Selectcar',
      component: Selectcar,
      meta: {
        title: '选择训练车型',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/selectschool',
      name: 'Selectschool',
      component: Selectschool,
      meta: {
        title: '选择驾校',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/selectstu',
      name: 'Selectstu',
      component: Selectstu,
      meta: {
        title: '选择学员',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/stuprogress',
      name: 'Stuprogress',
      component: Stuprogress,
      meta: {
        title: '学习进度',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/identifyjl',
      name: 'Identifyjl',
      component: Identifyjl,
      meta: {
        title: '教练认证',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true,
         keepAlive: true
      }
    },
    {
      path: '/identifyjx',
      name: 'Identifyjx',
      component: Identifyjx,
      meta: {
        title: '驾校认证',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true,
         keepAlive: true
      }
    },
    {
      path: '/identifyllpx',
      name: 'Identifyllpx',
      component: Identifyllpx,
      meta: {
        title: '理论培训认证',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true,
         keepAlive: true
      }
    },
    {
      path: '/identifytgy',
      name: 'Identifytgy',
      component: Identifytgy,
      meta: {
        title: '推广员认证',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true,
        keepAlive: true
      }
    },
    {
      path: '/merchantin',
      name: 'Merchantin',
      component: Merchantin,
      meta: {
        title: '商家入驻',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/myawards',
      name: 'Myawards',
      component: Myawards,
      meta: {
        title: '我的奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/wxoauth',
      name: 'Wxoauth',
      component: Wxoauth,
      meta: {
        title: '云学员一点通',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/shopdetail',
      name: 'Shopdetail',
      component: Shopdetail,
      meta: {
        title: '商户详情',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/detailinfo',
      name: 'Detailinfo',
      component: Detailinfo,
      meta: {
        title: '图文详情',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/detailjl',
      name: 'Detailjl',
      component: Detailjl,
      meta: {
        title: '教练详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true,
        keepAlive: false
      }
    },
    {
      path: '/detailjx',
      name: 'Detailjx',
      component: Detailjx,
      meta: {
        title: '驾校详情',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/stuinvite',
      name: 'Stuinvite',
      component: Stuinvite,
      meta: {
        title: '学员邀请',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/mypicture',
      name: 'Mypicture',
      component: Mypicture,
      meta: {
        title: '学员照片',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/mypicturedetail',
      name: 'Mypicturedetail',
      component: Mypicturedetail,
      meta: {
        title: '学员照片',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: '联系我们',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback,
      meta: {
        title: '意见反馈',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/newsdetail',
      name: 'Newsdetail',
      component: Newsdetail,
      meta: {
        title: '消息详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractlist',
      name: 'Contractlist',
      component: Contractlist,
      meta: {
        title: '合同审核',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractdetail',
      name: 'Contractdetail',
      component: Contractdetail,
      meta: {
        title: '合同详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/stulist',
      name: 'Stulist',
      component: Stulist,
      meta: {
        title: '我的学员',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/studetail',
      name: 'Studetail',
      component: Studetail,
      meta: {
        title: '学员详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/tuijianlilun',
      name: 'Tuijianlilun',
      component: Tuijianlilun,
      meta: {
        title: '理论推荐',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/tuijianvideo',
      name: 'Tuijianvideo',
      component: Tuijianvideo,
      meta: {
        title: '视频推荐',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/newslist',
      name: 'Newslist',
      component: Newslist,
      meta: {
        title: '我的消息',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/mywallet',
      name: 'Mywallet',
      component: Mywallet,
      meta: {
        title: '我的钱包',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/myteam',
      name: 'Myteam',
      component: Myteam,
      meta: {
        title: '我的团队',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/mypictureadd',
      name: 'Mypictureadd',
      component: Mypictureadd,
      meta: {
        title: '图片处理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/payinfo',
      name: 'Payinfo',
      component: Payinfo,
      meta: {
        title: '自助缴费',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/pay',
      name: 'Pay',
      component: Pay,
      meta: {
        title: '缴费支付',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/tixiandetail',
      name: 'Tixiandetail',
      component: Tixiandetail,
      meta: {
        title: '提现',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/tixianmx',
      name: 'Tixianmx',
      component: Tixianmx,
      meta: {
        title: '提现明细',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/yongjinmx',
      name: 'Yongjinmx',
      component: Yongjinmx,
      meta: {
        title: '佣金明细',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/walletorder',
      name: 'Walletorder',
      component: Walletorder,
      meta: {
        title: '分销订单',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/tuijianpicture',
      name: 'Tuijianpicture',
      component: Tuijianpicture,
      meta: {
        title: '图片处理推荐',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractjl',
      name: 'Contractjl',
      component: Contractjl,
      meta: {
        title: '合同处理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractexamine',
      name: 'Contractexamine',
      component: Contractexamine,
      meta: {
        title: '合同审核',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/setup',
      name: 'Setup',
      component: Setup,
      meta: {
        title: '个人信息',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/barcode',
      name: 'Barcode',
      component: Barcode,
      meta: {
        title: '扫一扫',
        isShowHead: false,
        isShowFoot: false,
        isShowBack: false
      }
    },
    {
      path: '/bindinginfo',
      name: 'Bindinginfo',
      component: Bindinginfo,
      meta: {
        title: '绑定提示',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/addprize',
      name: 'Addprize',
      component: Addprize,
      meta: {
        title: '发奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/prizesend',
      name: 'Prizesend',
      component: Prizesend,
      meta: {
        title: '已颁的奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/prize',
      name: 'Prize',
      component: Prize,
      meta: {
        title: '奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/prizeinfo',
      name: 'Prizeinfo',
      component: Prizeinfo,
      meta: {
        title: '发奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/prizelist',
      name: 'Prizelist',
      component: Prizelist,
      meta: {
        title: '发奖状',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/prizeuser',
      name: 'Prizeuser',
      component: Prizeuser,
      meta: {
        title: '选择学员',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/poster',
      name: 'Poster',
      component: Poster,
      meta: {
        title: '招生海报',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/posterdown',
      name: 'Posterdown',
      component: Posterdown,
      meta: {
        title: '招生海报',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/posterset',
      name: 'Posterset',
      component: Posterset,
      meta: {
        title: '招生海报',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/paiche',
      name: 'Paiche',
      component: Paiche,
      meta: {
        title: '指派车辆',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/yuyue',
      name: 'Yuyue',
      component: Yuyue,
      meta: {
        title: '预约车辆',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/infojx',
      name: 'Infojx',
      component: Infojx,
      meta: {
        title: '驾校管理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/infolist',
      name: 'Infolist',
      component: Infolist,
      meta: {
        title: '信息管理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/infoadd',
      name: 'Infoadd',
      component: Infoadd,
      meta: {
        title: '信息发布',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/setupjx',
      name: 'Setupjx',
      component: Setupjx,
      meta: {
        title: '驾校管理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/setupjl',
      name: 'Setupjl',
      component: Setupjl,
      meta: {
        title: '教练管理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/infogl',
      name: 'Infogl',
      component: Infogl,
      meta: {
        title: '信息管理',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      meta: {
        title: '地图位置',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractlists',
      name: 'Contractlists',
      component: Contractlists,
      meta: {
        title: '已审合同',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractinfo',
      name: 'Contractinfo',
      component: Contractinfo,
      meta: {
        title: '报名详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/contractschool',
      name: 'Contractschool',
      component: Contractschool,
      meta: {
        title: '合同详情',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
	{
	  path: '/obtain',
	  name: 'Obtain',
	  component: Obtain,
	  meta: {
	    title: '积分获取',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
    {
      path: '/conserve',
      name: 'Conserve',
      component: Conserve,
      meta: {
        title: '题库',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/conservevideo',
      name: 'Conservevideo',
      component: Conservevideo,
      meta: {
        title: '视频',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/introduce',
      name: 'Introduce',
      component: Introduce,
      meta: {
        title: '考场介绍',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
	{
	  path: '/shoplist',
	  name: 'Shopliat',
	  component: Shoplist,
	  meta: {
	    title: '商城列表',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/sharelist',
	  name: 'Sharelist',
	  component: Sharelist,
	  meta: {
	    title: '选择图片',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/sharequestions',
	  name: 'Sharequestions',
	  component: Sharequestions,
	  meta: {
	    title: '题库分享',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/sharephoto',
	  name: 'Sharephoto',
	  component: Sharephoto,
	  meta: {
	    title: '图片处理分享',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/sharevideo',
	  name: 'Sharevideo',
	  component: Sharevideo,
	  meta: {
	    title: '视频分享',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/promoter',
	  name: 'Promoter',
	  component: Promoter,
	  meta: {
	    title: '代理管理',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/proxylogin',
	  name: 'Proxylogin',
	  component: Proxylogin,
	  meta: {
	    title: '代理登录',
	    isShowHead: false,
	    isShowFoot: false,
	    isShowBack: false
	  }
	},
	{
	  path: '/proxywallet',
	  name: '',
	  component: Proxywallet,
	  meta: {
	    title: '代理钱包',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
  {
    path: '/proxytixian',
    name: 'pro',
    component: Proxytixian,
    meta: {
      title: '代理提现',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
	{
	  path: '/proxyprofit',
	  name: 'Proxyprofit',
	  component: Proxyprofit,
	  meta: {
	    title: '收益明细',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/myproxy',
	  name: 'Myproxy',
	  component: Myproxy,
	  meta: {
	    title: '我的代理',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/myproxyxia',
	  name: 'Myproxyxia',
	  component: Myproxyxia,
	  meta: {
	    title: '下级代理',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/proxycode',
	  name: 'Proxycode',
	  component: Proxycode,
	  meta: {
	    title: '代理二维码',
	    isShowHead: false,
	    isShowFoot: false,
	    isShowBack: false
	  }
	},
	{
	  path: '/integral',
	  name: 'Integral',
	  component: Integral,
	  meta: {
	    title: '积分详情',
	    isShowHead: false,
	    isShowFoot: false,
	    isShowBack: false
	  }
	},
	{
	  path: '/proxymix',
	  name: 'Proxymix',
	  component: Proxymix,
	  meta: {
	    title: '收益占比',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/income',
	  name: 'Income',
	  component: Income,
	  meta: {
	    title: '收益详情',
	    isShowHead: false,
	    isShowFoot: false,
	    isShowBack: false
	  }
	},
	{
	  path: '/learn',
	  name: 'Learn',
	  component: Learn,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/fee',
	  name: 'Fee',
	  component: Fee,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true,
      keepAlive: true
	  }
	},
	{
	  path: '/subjectlist',
	  name: 'Subjectlist',
	  component: Subjectlist,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/subjectlistresult',
	  name: 'Subjectlistresult',
	  component: Subjectlistresult,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/corder',
	  name: 'Corder',
	  component: Corder,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/video',
	  name: 'Video',
	  component: Video,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/video1',
	  name: 'Video1',
	  component: Video1,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/videodetail',
	  name: 'Videodetail',
	  component: Videodetail,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/videovip',
	  name: 'Videovip',
	  component: Videovip,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
	{
	  path: '/vip',
	  name: 'Vip',
	  component: Vip,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
  {
    path: '/subjectvip',
    name: 'Subjectvip',
    component: Subjectvip,
    meta: {
      title: '云学员一点通',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
	{
	  path: '/result',
	  name: 'Result',
	  component: Result,
	  meta: {
	    title: '云学员一点通',
	    isShowHead: true,
	    isShowFoot: false,
	    isShowBack: true
	  }
	},
  {
    path: '/h5Index',
    name: 'H5Index',
    component: H5Index,
    meta: {
      title: '云学员一点通',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true,
      keepAlive: true
    }
  },
  {
    path: '/chapter',
    name: 'Chapter',
    component: Chapter,
    meta: {
      title: '云学员一点通',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
  {
    path: '/compensate',
    name: 'Compensate',
    component: Compensate,
    meta: {
      title: '云学员一点通',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
  {
    path: '/wrong',
    name: 'Wrong',
    component: Wrong,
    meta: {
      title: '云学员一点通',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: {
      title: '我的订单',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
  {
    path: '/payresult',
    name: 'Payresult',
    component: Payresult,
    meta: {
      title: '支付详情',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: false
    }
  },
  {
    path: '/videocourse',
    name: 'Videocourse',
    component: Videocourse,
    meta: {
      title: '视频课程',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
  {
    path: '/feevideo',
    name: 'Feevideo',
    component: Feevideo,
    meta: {
      title: '视频讲解',
      isShowHead: false,
      isShowFoot: false,
      isShowBack: false
    }
  },
  {
    path: '/myextension',
    name: 'Myextension',
    component: Myextension,
    meta: {
      title: '推广人',
      isShowHead: true,
      isShowFoot: false,
      isShowBack: true
    }
  },
    {
      path: '/compensateform',
      name: 'Compensateform',
      component: Compensateform,
      meta: {
        title: '云学员一点通',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/rankingtg',
      name: 'Rankingtg',
      component: Rankingtg,
      meta: {
        title: '推广人收益排名',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
    {
      path: '/rankingdl',
      name: 'Rankingdl',
      component: Rankingdl,
      meta: {
        title: '代理收益排名',
        isShowHead: true,
        isShowFoot: false,
        isShowBack: true
      }
    },
	{
		path: '/invite',
		name: 'Invite',
		component: Invite,
		meta: {
		    title: '邀请分享',
		    isShowHead: true,
		    isShowFoot: false,
		    isShowBack: true
		}
	},
	{
		path: '/oilIndex',
		name: 'OilIndex',
		component: OilIndex,
		meta: {
		    title: '加油',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/search',
		name: 'Search',
		component: Search,
		meta: {
		    title: '搜索',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/recharge',
		name: 'Recharge',
		component: Recharge,
		meta: {
		    title: '充值',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/rechargerecord',
		name: 'Rechargerecord',
		component: Rechargerecord,
		meta: {
		    title: '充值记录',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/personal',
		name: 'Personal',
		component: Personal,
		meta: {
		    title: '我的',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/Exchangerecord',
		name: 'Exchangerecord',
		component: Exchangerecord,
		meta: {
		    title: '消费记录',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilcontact',
		name: 'Oilcontact',
		component: Oilcontact,
		meta: {
		    title: '联系我们',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oildetail',
		name: 'Oildetail',
		component: Oildetail,
		meta: {
		    title: '加油站',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilabout',
		name: 'Oilabout',
		component: Oilabout,
		meta: {
		    title: '关于我们',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilsettle',
		name: 'Oilsettle',
		component: Oilsettle,
		meta: {
		    title: '加油站入驻',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilfeedback',
		name: 'Oilfeedback',
		component: Oilfeedback,
		meta: {
		    title: '意见反馈',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilpromoter',
		name: 'Oilpromoter',
		component: Oilpromoter,
		meta: {
		    title: '代理管理',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilagent',
		name: 'Oilagent',
		component: Oilagent,
		meta: {
		    title: '代理中心',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/Cardquery',
		name: 'Cardquery',
		component: Cardquery,
		meta: {
		    title: '充值卡查询',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/Cardrecharge',
		name: 'Cardrecharge',
		component: Cardrecharge,
		meta: {
		    title: '代充',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/Cardmerchant',
		name: 'Cardmerchant',
		component: Cardmerchant,
		meta: {
		    title: '划卡到商户',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/Cardagent',
		name: 'Cardagent',
		component: Cardagent,
		meta: {
		    title: '划卡到代理',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/rebate',
		name: 'Rebate',
		component: Rebate,
		meta: {
		    title: '返利设置',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/cardadminister',
		name: 'Cardadminister',
		component: Cardadminister,
		meta: {
		    title: '卡号卡密管理',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/cardrecord',
		name: 'Cardrecord',
		component: Cardrecord,
		meta: {
		    title: '划卡记录',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilpartner',
		name: 'Oilpartner',
		component: Oilpartner,
		meta: {
		    title: '合伙人中心',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilorder',
		name: 'Oilorder',
		component: Oilorder,
		meta: {
		    title: '订单',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oilmember',
		name: 'Oilmember',
		component: Oilmember,
		meta: {
		    title: '会员详情',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/profitrecord',
		name: 'Profitrecord',
		component: Profitrecord,
		meta: {
		    title: '收益记录',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/oiltixian',
		name: 'Oiltixian',
		component: Oiltixian,
		meta: {
		    title: '提现',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/redeem',
		name: 'Redeem',
		component: Redeem,
		meta: {
		    title: '积分兑换',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	{
		path: '/rechargeproduct',
		name: 'Rechargeproduct',
		component: Rechargeproduct,
		meta: {
		    title: '领取赠品',
		    isShowHead: false,
		    isShowFoot: false,
		    isShowBack: false
		}
	},
	// 优惠卡券
	{
		path: '/discount',
		name: 'Discount',
		component: Discount,
		meta: {
		    title: '优惠卡券',
		    isShowHead: true,
		    isShowFoot: false,
		    isShowBack: true
		}
	},
	{
		path: '/discountdetail',
		name: 'Discountdetail',
		component: Discountdetail,
		meta: {
		    title: '优惠卡券详情',
		    isShowHead: true,
		    isShowFoot: false,
		    isShowBack: true
		}
	},
	{
		path: '/discountshop',
		name: 'Discountshop',
		component: Discountshop,
		meta: {
		    title: '优惠网点',
		    isShowHead: true,
		    isShowFoot: false,
		    isShowBack: true
		}
	},
	{
		path: '/discountshopdetail',
		name: 'Discountshopdetail',
		component: Discountshopdetail,
		meta: {
		    title: '网点详情',
		    isShowHead: true,
		    isShowFoot: false,
		    isShowBack: true
		}
	}
  ]
})



router.beforeEach((to, from, next) => {
  if (to.name == 'Wxoauth') {
    next();
  } else {
    if (!localStorage.getItem('login_user')) {
      if (window.plus) {
        next({
          path: '/wxoauth'
        });
      } else {
        document.addEventListener("plusready", function() {
          next({
            path: '/wxoauth'
          });
        });
      }
    } else {
      next();
    }
  }
})

router.afterEach(function(to, from) {
  // console.log(to.meta.title,to.meta.isShowBack)
  var toL = to.path.split('/').length;
  var fromL = from.path.split('/').length;
  var trans;
  if (toL == fromL) {
    trans = 'fade'
  } else {
    trans = toL > fromL ? 'next' : 'prev'
  }
  if (to.meta.title) {
    store.dispatch("updateNavbarTitle", to.meta.title);
    //过渡效果
    store.dispatch('updateTransition', trans)
    store.dispatch('updateNavbarStatus', {
      isShowHead: to.meta.isShowHead,
      isShowFoot: to.meta.isShowFoot,
      isShowBack: to.meta.isShowBack
    })
    document.title = to.meta.title || "";
  }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js